import memoize from 'moize';

export const getImageUrlFromContentfulImage = memoize.deep((image: any) => image?.file?.url);
export const getTitleFromContentfulImage = memoize.deep((image: any) => image?.title);
